/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
const is = require("is_js");

const SERVICE_NAME = "MyPoliciesDetailService";
const log: any = LoggerModule.getInstance();

export class MyPoliciesDetailPageService {
  private static instance: MyPoliciesDetailPageService;
  private vapp: VApplication;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): MyPoliciesDetailPageService {
    if (!MyPoliciesDetailPageService.instance) {
      MyPoliciesDetailPageService.instance = new MyPoliciesDetailPageService(
        props
      );
    }
    return MyPoliciesDetailPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    // //Main Props
    // compProps = await agent.getMainSectionProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    //Feature Section Props
    compProps = await agent.getFeatureSectionProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Footer Props
    compProps = await agent.getFooterProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public formatPolicyDetail(args: any) {
    const agent = getAgent();
    return agent.getFormatPolicyDetailSync(args);
  }

  public async getBlockchainProof(args:any){
    const agent = getAgent();
    return await agent.getBlockchainProofProps(args);
  }

  public getTransactionList(args?:any) {
    const agent = getAgent();
    return agent.getGetTransactionListProps(args);
  }

  public formatTimeLineDetail(args: any) {
    console.log(`blockchain proof url in `, args);
    const agent = getAgent();
    let content: any = {};
    let compProps: any = null;

    //format details

    compProps = agent.getFormatTimelineDetailSync(args);
    if(compProps){
      content = {...content, ...compProps};
    }

    return content;
    
  }

  public updateAckStatus(args: any) {
    const agent = getAgent();
    return agent.getUpdateAckStatus(args);
  }

  public cancelPolicy(args:any) {
    const agent = getAgent();
    return agent.getCancelPolicyStatus(args);
  }
}
